import { PricingTab } from '@/features/leads/components/Detail/Tabs/PricingTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/pricing')({
  component: PricingTab,
});
